<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2023-12-15 14:43:28
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 15:07:20
 * @Description: 
 * @FilePath: \src\components\order\OrderRefundAuditDetail.vue
-->
<template>
  <div class="order-refund-detail">
    <!-- <div v-if="type == 'refund'" class="tuolele-main-box">
      <div class="flex-wrap">
        <div class="flex-con">
          <div class="order-count">
            <span>所有订单</span>
            <p class="bold">{{ dataInfo.count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待销售审核</span>
            <p class="bold">{{ dataInfo.saler_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待校长审核</span>
            <p class="bold">{{ dataInfo.schoolmaster_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待总部审核</span>
            <p class="bold">{{ dataInfo.regional_director_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>待财务审核</span>
            <p class="bold">{{ dataInfo.finance_audit_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>审核成功</span>
            <p class="bold">{{ dataInfo.audit_success_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>审核失败</span>
            <p class="bold">{{ dataInfo.audit_fail_count }}</p>
          </div>
        </div>
        <div class="flex-con">
          <div class="order-count">
            <span>学员数量（去重后）</span>
            <p class="bold">{{ dataInfo.children_unique_count }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="table-header fn-clear">
      <div class="fn-right export-btn">
        <el-button type="success" @click="exportExcel">导出Excel表</el-button>
      </div>
      <div class="fn-right table-header-right">
        <el-pagination
          :current-page.sync="search.p"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search.limit"
          layout="sizes, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          @size-change="handleSizeChange"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
      </div>
    </div> -->
    <div class="tuolele-main-box">
      <el-table :data="dataInfo.list" border stripe @sort-change="tableSort">
        <el-table-column
          prop="type_name"
          label="类型"
        />
        <el-table-column
          prop="create_time"
          label="创建时间"
          sortable
        />
        <el-table-column
          prop="modify_time"
          label="最后操作时间"
          sortable
        />
        <el-table-column
          prop="shop_name"
          label="店铺"
        />
        <el-table-column prop="refund_id" label="退款单号" />
        <el-table-column
          prop="item_title"
          label="套餐"
        />
        <el-table-column label="学员">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.sub_name }}</div>
            <div class="color-gray">ID：{{ scope.row.relation_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="退款金额">
          <template slot-scope="scope">
            <div class="color-black">￥{{ scope.row.amount / 100 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="editor_name" label="提交人" />
        <el-table-column
          prop="salesperson_name"
          label="所属销售"
        />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="getOrderInfo(scope.row)">{{
              type == "refund" ? "查看订单" : "审核订单"
            }}</el-button>
            <el-button
              v-if="scope.row.extra.refundReason && type == 'refund'"
              type="text"
              @click="refundBillDetail(scope.row)"
            >挽单信息</el-button>
            <el-button
              type="text"
              @click="orderImg(scope.row)"
            >电子合同</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="search.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="search.limit"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div> -->
    <el-dialog
      title="退款详情"
      :visible.sync="dialogVisible1"
      width="40%"
      :before-close="handleClose"
      class="order-detail-dialog"
    >
      <OrderRefundAuditInfo
        :order-detail="orderDetail"
        :type="type"
        @updateOrderList="getRefundList"
      />
    </el-dialog>
    <el-dialog
      title="挽单信息"
      :visible.sync="dialogVisible2"
      width="40%"
      :before-close="handleClose"
    >
      <div class="refund-bill-list">
        <div class="color-black">退款过程及原因分析</div>
        <p>{{ retrieve.refundReason }}</p>
      </div>
      <div class="refund-bill-list">
        <div class="color-black">挽单过程及补救措施</div>
        <p>{{ retrieve.refundProcess }}</p>
      </div>
      <div class="refund-bill-list">
        <div class="color-black">责任分析与经验总结</div>
        <p>{{ retrieve.refundConclusion }}</p>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible3"
      title="合同预览"
      class="order-img"
    >
      <div class="agreement_picture">
        <div class="pdf">
          <iframe
            :src="src"
            frameborder="0"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OrderRefundAuditInfo from '@/components/order/OrderRefundAuditInfo.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'OrderRefundAuditDetail',
  components: {
    OrderRefundAuditInfo
  },
  props: {
    type: String,
    search: Object
  },
  data() {
    return {
      dataInfo: {},
      itemTotal: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      orderDetail: {},
      retrieve: {},
      src: ''
    }
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.getRefundList()
      }
    }
  },
  mounted() {
    this.getRefundList()
  },
  methods: {
    // exportExcel() {
    //   const tHeader = [
    //     '创建时间',
    //     '最后操作时间',
    //     '退款单号',
    //     '学员',
    //     '退款金额',
    //     '提交人',
    //     '第一责任人',
    //     '订单审核状态'
    //   ]
    //   const filterVal = [
    //     'create_time',
    //     'modify_time',
    //     'refund_id',
    //     'sub_name',
    //     'amount',
    //     'editor_name',
    //     'headmaster_name',
    //     'status_name'
    //   ]
    //   let list = JSON.stringify(this.dataInfo.list)
    //   list = JSON.parse(list)
    //   list.forEach(e => {
    //     e.amount = e.amount / 100
    //     e.sub_name = e.sub_name + ',ID' + e.relation_id
    //   })
    //   Tool.exportExcel(tHeader, filterVal, list, '退款订单')
    // },
    getRefundList() {
      this.dialogVisible1 = false
      this.$http.getRefundOrderAuditList(this.search).then(res => {
        this.dataInfo = res.data
        // this.itemTotal = res.data.count - 0
      })
    },
    getOrderInfo(row) {
      this.dialogVisible1 = false
      this.$http.getRefundInfo({ refund_id: row.refund_id }).then(res => {
        this.orderDetail = res.data
        this.dialogVisible1 = true
      })
    },
    orderImg(row) {
      this.dialogVisible3 = true
      this.src = row.extra.order_img
    },
    refundBillDetail(row) {
      this.dialogVisible2 = true
      this.retrieve = row.extra || {}
    },
    handleClose() {
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.dialogVisible3 = false
    },
    tableSort(val) {
      this.search.order_key = val.prop
      this.search.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.search.p = 1
      this.getRefundList()
    },
    handleSizeChange(val) {
      this.search.limit = val
    }
  }
}
</script>

<style lang="scss">
.order-refund-detail {
  .export-btn {
    margin: 0 40px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .refund-bill-list {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
    div {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
  .order-img .el-dialog {
    height: 95% !important;
    .el-dialog__body {
      height: 90%;
    }
    .agreement_picture,
    .pdf {
      height: 100%;
    }
  }
}
</style>
